import React, { useState, useEffect } from "react";
import "./NeedPermissionsScreen.css";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import MicIcon from "@mui/icons-material/Mic";
import GppGoodIcon from "@mui/icons-material/GppGood";
import { Button, Divider } from "@mui/material";
import NeedAssessComponent from "./Components/NeedAssessComponent/NeedAssessComponent";
import GrantPermissionsStepsDialog from "../../components/GrantPermissionsStepsDialog/GrantPermissionsStepsDialog";
import useTranslationSetup from "../../utils/useTranslationSetup";
import PermissionsStatusLoader from "./Components/PermissionsStatusLoader/PermissionsStatusLoader";
import { SCREENS } from "../../utils/CommonUtils/constants";

function NeedPermissionsScreen({ setLatitude, setLongitude, setActiveScreen }) {
  const { t } = useTranslationSetup();
  const [audioPermissions, setAudioPermissions] = useState(null);
  const [locationPermissions, setLocationPermissions] = useState(null);
  const [
    openPermissionsInformationDialog,
    setOpenPermissionsInformationDialog,
  ] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (audioPermissions !== null) {
      setShowLoader(false);
    }
    if (audioPermissions === "DENIED") {
      setOpenPermissionsInformationDialog(true);
    }
    if (audioPermissions === "GRANTED") {
      setActiveScreen(SCREENS.RENDER_INSTRUCTIONS_SCREEN);
    }
  }, [audioPermissions, locationPermissions]);

  function askAudioPermissions() {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        setAudioPermissions("GRANTED");
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch(() => {
        setAudioPermissions("DENIED");
      });
  }

  function askGeolocationPermissions() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setLocationPermissions("GRANTED");
        },
        () => {
          setLocationPermissions("DENIED");
        }
      );
    } else {
      setLocationPermissions("GEOLOCATION_NOT_SUPPORTED");
    }
  }

  function askPermissions() {
    setShowLoader(true);
    askGeolocationPermissions();
    askAudioPermissions();
  }

  const onClickGrantPermissionsStepsDialog = () => {
    setOpenPermissionsInformationDialog(false);
    setAudioPermissions(null);
    setLocationPermissions(null);
  };

  return (
    <div className="need-permissions-container">
      <PermissionsStatusLoader open={showLoader} />
      <GrantPermissionsStepsDialog
        isDialogOpen={openPermissionsInformationDialog}
        onClick={onClickGrantPermissionsStepsDialog}
      />
      <div className="need-permissions-screen-heading">
        {t("need_permissions")}
      </div>
      <div className="need-permissions-screen-desc">
        {t("need_permissions_description")}
      </div>
      <div className="need-to-assess-text">{t("we_need_to_access")}</div>
      <div className="need-assess-container">
        <NeedAssessComponent
          icon={<FmdGoodIcon />}
          heading={t("location_access")}
          content={t("location_access_description")}
        />
        <Divider
          style={{
            margin: "18px 10%",
          }}
        />
        <NeedAssessComponent
          icon={<MicIcon />}
          heading={t("microphone_access")}
          content={t("microphone_access_description")}
        />
      </div>
      <div className="need-assess-container">
        <NeedAssessComponent
          icon={<GppGoodIcon />}
          heading={t("data_security")}
          content={t("data_security_description")}
        />
      </div>
      <div
        style={{
          textAlign: "center",
        }}
        className="sticky-approve-button"
      >
        <Button
          className="need-permission-button theme-background"
          variant="contained"
          disableElevation
          onClick={() => {
            askPermissions();
          }}
        >
          {t("i_approve")}
        </Button>
      </div>
    </div>
  );
}

export default NeedPermissionsScreen;
